module.exports = __webpack_public_path__ + "static/media/salad.832936f1.jpg";